import type { ISectionSummary } from '@services/types';

import { classesBuilder } from '@common/helpers';
import Card from '@components/Card';
import Icon from '@components/Icon';
import type { ISectionComponentProps } from '@components/ReportContent/types';
import { TimelineItem } from '@components/TimelineItem';

import { useSummaryTimeline } from './hooks';

import '../section.scss';
import style from './styles.module.scss';

// TODO: Replace static TIMELINE_ITEMS with dynamic data from sectionData when available.
// For now, using static data for development and testing purposes.
const TIMELINE_ITEMS = [
  {
    title: 'VIEWABILITY OUTPERFORMED BENCHMARK',
    description:
      '98.4% viewable rate across 12.3M measured impressions — 14 points above the IAS industry benchmark for premium mobile inventory.',
  },
  {
    title: 'BRAND-SAFE ENVIRONMENT MAINTAINED',
    description:
      '99.7% pass rate on brand-safety filters with zero high-risk incidents flagged across the full flight window.',
  },
  {
    title: 'TIME-IN-VIEW DROVE ENGAGEMENT',
    description:
      'Average time-in-view of 8.2s exceeded the planned 5s threshold, contributing to a 23% lift in interaction rate vs. last campaign.',
  },
  {
    title: 'HIGH-IMPACT CREATIVES DELIVERED EFFICIENCY',
    description:
      'VIS.X®-served high-impact formats produced a 31% lower effective CPM than standard formats, driving cost-efficient performance.',
  },
];

const SummarySection = ({ sectionData }: ISectionComponentProps) => {
  const { sectionRef, iconRefs, activeStates } = useSummaryTimeline(TIMELINE_ITEMS.length);

  if (!('data' in sectionData) || !sectionData.data) {
    return <div>Error: Invalid data for Summary section.</div>;
  }

  const { data } = sectionData as ISectionSummary;

  return (
    <div
      ref={sectionRef}
      className={classesBuilder('section-wrapper', style['summary-wrapper'])}
    >
      <div className="section-header">
        <h3 className="section-subtitle">Campaign Review</h3>
        <h1 className="section-title">SUMMARY</h1>
      </div>

      <div className={style['summary-content']}>
        <Card>
          <div className={style['highlight-card-body']}>
            <div className={style['badge-icon-wrapper']}>
              <Icon
                name="sparkle"
                className={style['highlight-icon']}
              />
            </div>
            <div className={style['highlight-text-content']}>
              <div className={style['badge-label']}>AI GENERATED</div>
              <p className={style['intro-text']}>{data.text || TIMELINE_ITEMS[0].description}</p>
            </div>
          </div>
        </Card>

        <Card>
          <div className={style['timeline-container']}>
            {TIMELINE_ITEMS.map((item, index) => {
              return (
                <TimelineItem
                  key={`${index}-${item.title}`}
                  title={item.title}
                  description={item.description}
                  isActive={activeStates[index]}
                  isLineActive={activeStates[index] || activeStates[index + 1]}
                  showLine={index < TIMELINE_ITEMS.length - 1}
                  iconRef={(element) => {
                    iconRefs.current[index] = element;
                  }}
                />
              );
            })}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SummarySection;
